function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_16508",
    "data-name": "Group 16508",
    transform: "matrix(0.93617, 0, 0, 0.93617, -4100.744629, 6308.270508)",
    style: {}
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_792",
    "data-name": "Line 792",
    x2: 14,
    y2: 14,
    transform: "translate(4382 -6736.808)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    style: {
      stroke: "rgb(6, 35, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37366",
    "data-name": "Path 37366",
    d: "M10.46,10.587a1.577,1.577,0,0,0,2.23,2.231",
    transform: "translate(4377.308 -6741.605)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    style: {
      stroke: "rgb(6, 35, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37367",
    "data-name": "Path 37367",
    d: "M7.805,5.288A7.463,7.463,0,0,1,9.884,5q4.731,0,7.884,5.519a15,15,0,0,1-1.973,2.75m-1.687,1.467a7.4,7.4,0,0,1-4.224,1.3q-4.731,0-7.884-5.519A12.373,12.373,0,0,1,5.652,6.308",
    transform: "translate(4379 -6740.423)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    style: {
      stroke: "rgb(6, 35, 61)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEye);
export default __webpack_public_path__ + "static/media/hiddenEye.672802036629c94fd7cf094426ef7087.svg";
export { ForwardRef as ReactComponent };